module.exports = __webpack_public_path__ + "img/demographicIcon.eaa85f50.png";